import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { HubBreadcrumbComponent } from './hub-breadcrumb.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        RouterModule,
    ],
    exports: [ HubBreadcrumbComponent ],
    declarations: [ HubBreadcrumbComponent ],
})
export class HubBreadcrumbModule {}
